import { render } from "./ShueishaMangasaiProfile.vue?vue&type=template&id=02f77e33&scoped=true&ts=true"
import script from "./ShueishaMangasaiProfile.vue?vue&type=script&lang=ts"
export * from "./ShueishaMangasaiProfile.vue?vue&type=script&lang=ts"

import "./ShueishaMangasaiProfile.vue?vue&type=style&index=0&id=02f77e33&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f77e33"]])

export default __exports__